import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/axios";
import { toast } from "react-toastify";

// Fetch users
export const fetchUsers = createAsyncThunk(
  "users/fetch",
  async (projectId, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (projectId) params.append("projectId", projectId);
      const url = `/api/users${projectId ? `?${params.toString()}` : ""}`;
      const res = await api.get(url);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Add a new user
export const addUser = createAsyncThunk(
  "users/add",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/users", userData);
      toast.success(res.data.message || "Email sent to set password");
      return res.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Failed to add user";
      toast.error(errorMessage);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update a user
export const updateUser = createAsyncThunk(
  "users/update",
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/api/users/${id}`, updatedData);
      toast.success("User updated successfully");
      return res.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to update user";
      toast.error(errorMessage);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete a user
export const deleteUser = createAsyncThunk(
  "users/delete",
  async ({ id, projectId }, { rejectWithValue }) => {
    try {
      const url = `/api/users/${id}${
        projectId ? `?projectId=${projectId}` : ""
      }`;
      const res = await api.delete(url);
      toast.success(res.data.message || "User removed successfully");
      return id;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to delete user";
      toast.error(errorMessage);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
